export const labelStyle: React.CSSProperties = {
  background: 'white',
  padding: '3px 8px',
  borderRadius: '5px',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  color: '#000000',
  fontWeight: 'bold',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  pointerEvents: 'none', 
  minWidth: 'max-content',
  transform: 'translate(-50%, -100%) translateY(-5px)'
};
